import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import api from '../../services/api';
import ReactHtmlParser from 'react-html-parser';

export default class Ouvidoria extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }
   
   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await api.get('/pages?slug=ouvidoria');
      this.setState({ dados: data });
   }

   // armazena os dados no estado
   state = {
      dados: [],
   }

   // renderiza o componente 
   render(){
      return ( 
         <div>
            {/* percorre o array de dados e exibe */}
            { this.state.dados.map ( dado => (
               <div key = { dado.id }> 
                  <div className="text-white bg-secondary py-5">
                     <Container>
                        <h2> {dado.title.rendered}</h2> <hr />
                     </Container>
                  </div>
                  <Container>
                     <Row className="py-5">
                        <Col >
                           { ReactHtmlParser(dado.content.rendered)}
                        </Col>
                     </Row>
                  </Container>
               </div>             
            )) }                        
         </div>
      )
   }
}